export default "__VITE_ASSET__CUcGm1TP__"